import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAppSelector, useAppDispatch } from '../reduxhooks';
import { Box, Dialog, IconButton, Link, Slide, Typography, Divider } from '@material-ui/core';
import OverlayComponentBaseContainerHorizontal from './OverlayComponentBaseContainerHorizontal';
import { ArrowBack, Backspace } from '@material-ui/icons';
import OverlayComponentBaseContainerWidth from './OverlayComponentBaseContainerWidth';
import OverlayComponentTitle from './OverlayComponentTitle';

import DoneIcon from '@material-ui/icons/Done';

import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";

interface StyleProps {
  width: string
}

const useStyles = ({ width }: StyleProps) => makeStyles((theme: Theme) =>
  createStyles({
    barContainer: {
      display:'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      paddingTop: '6px',
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
      width: '100%',
    },
    horizontalBarProgressBackground: {
      height: '1px',
      width: '220px',
      backgroundColor: '#aaa',
      position: 'relative',
      // marginTop: '20px',
    },
    horizontalBarProgress: {
      position: 'absolute',
      height: '2px',
      bottom: '-1px',
      backgroundColor: '#000',
      transition: 'all .25s linear',
      width: width,
    },
    orderProgressBarContainer: {
      marginTop: "30px",
      marginBottom: "20px",
      paddingLeft: "40px",
      paddingRight: "40px",
      paddingTop: "50px",
      paddingBottom: "80px",
    },
    orderProgressBarPointGreened: {
      width: "35px",
      height: "35px",
      borderRadius: "104px",
      backgroundColor: "#30ac0a",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    orderProgressBarPointGreyed: {
      width: "35px",
      height: "35px",
      borderRadius: "104px",
      backgroundColor: "#B9B9B9",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    orderProgressBarPoint: {
      width: "35px",
      height: "35px",
      borderRadius: "104px",
      backgroundColor: "#1c1c1c",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    orderProgressBarText: {
      textAlign: "center",
      width: "35px",
      paddingTop: "8.5px",
      fontSize: "13px",
      fontWeight: 400,
      color: "#ffffff"
    },
    orderProgressBarDoneIcon: {
      color: "#ffffff",
      paddingTop: "6px",
      width: "22px",
      height: "22px"
    },
    orderProgressPointImageIcon: {
      position: "absolute",
      top: "-60px",
    },
    orderProgressPointDescription: {
      fontSize: "10px",
      fontWeight: 300,
      textAlign: "center",
      position: "absolute",
      top: "46px",
    },
  }),
);

const nameSrcArray = [
  "Mulai",
  "Pilih Ukuran",
  "Sesuaikan Ukuran",
  "Hasil Kamu" 
];


interface BackButtonSegmentProps {
  currentIndex: number
}

export default function VerticalBar({ currentIndex }: BackButtonSegmentProps) {
  // let calcHeight = 0;
  // calcHeight = 100 * (current - start)/(end - start); 
  // const classes = useStyles({width: calcHeight.toString() + '%' })();
  const classes = useStyles({width: '0%'})();

  if (currentIndex === -1) {
    return null;
  }

  return (
    <Box style={{padding: '64px 14px 24px', margin: '20px 56px'}}>
    <ProgressBar percent={(currentIndex - 1) * 100 / 2} height={3} filledBackground="#1c1c1c" unfilledBackground="#B9B9B9">
      <Step transition="scale">
        {({ accomplished }) => (
          <Box className={accomplished ? classes.orderProgressBarPoint : classes.orderProgressBarPointGreyed}>
            <Typography className={classes.orderProgressBarText}>1</Typography>
            <Typography className={classes.orderProgressPointDescription}>{nameSrcArray[1]}</Typography>
          </Box>
        )}
      </Step>
      <Step transition="scale">
        {({ accomplished }) => (
          <Box className={accomplished ? classes.orderProgressBarPoint : classes.orderProgressBarPointGreyed}>
            <Typography className={classes.orderProgressBarText}>2</Typography>
            <Typography className={classes.orderProgressPointDescription}>{nameSrcArray[2]}</Typography>
          </Box>
        )}
      </Step>
      <Step transition="scale">
        {({ accomplished }) => (
          <Box className={accomplished ? classes.orderProgressBarPointGreened : classes.orderProgressBarPointGreyed}>
            <DoneIcon className={classes.orderProgressBarDoneIcon} />
            <Typography className={classes.orderProgressPointDescription}>{nameSrcArray[3]}</Typography>
          </Box>
        )}
      </Step>
    </ProgressBar>
    </Box>
  );

  // return (
  //   <div className={classes.barContainer}>
  //     <OverlayComponentTitle text={'0' + current.toString() + '.'} fontSizeMobile='14px'/>
  //     <div className={classes.horizontalBarProgressBackground}>
  //       <div className={classes.horizontalBarProgress}>
  //       </div>
  //     </div>
  //     <OverlayComponentTitle text={'0' + end.toString() + '.'} fontSizeMobile='14px'/>
  //   </div>
  // )
}